export default __webpack_public_path__ + "static/media/password.ed6beb12.svg";